import React, { useEffect, useState } from 'react';
import { canManageIssues, collectGarbage, goTo, setHelpPage, setWindowTitle, waiverEditOnly } from '../configTdm';
import { getProperty } from '../fsConfig';
import { searchIssuesService } from '../issues/issueService';
import ManageIssues from '../issues/ManageIssues';
import { Issue } from './interfaces';

// TODO: Move the type definition for issue to a separate file in the issues directory

const HomePage: React.FC = () => {
  const [myIssues, setMyIssues] = useState<Issue[]>([]);

  const cleanup = () => {
    setMyIssues([]);
    collectGarbage();
  };

  useEffect(() => {
    if (waiverEditOnly()) {
      goTo('/waivers');
    }

    setHelpPage('helpHome');

    if (canManageIssues()) {
      getMyIssues();
    }

    return () => {
      cleanup();
    };
  }, []);

  const getMyIssues = async () => {
    const params = [];
    params.push(`assignee=${getProperty('session', {}).name}`);
    params.push(`state=${encodeURIComponent('open,assisting')}`);
    params.push('sortBy=time');
    params.push('limit=5');
    params.push('order=ascending');

    try {
      const resp = await searchIssuesService.fetch(params.join('&'));
      if (resp?.data?.issues?.length > 0) {
        setMyIssues(resp.data.issues);
      }
    } catch (error) {
      console.error('Failed to fetch issues:', error);
    }
  };

  return (
    <div className="home">
      <div className="row">
        <div className="col-md-4 my">
          {canManageIssues() && <ManageIssues myIssues={myIssues} />}
        </div>
      </div>
    </div>
  );
};

export default HomePage;